module.exports = __webpack_public_path__ + "img/polygone.bbd2e461.png";